<template>
  <div class="imageBox">
    <div v-if="imageList.length"
         class="imageBox_container row no-gutters">
      <div class="row color">
        <template v-for="(item, index) in imageList">
          <div :key="index"
               class="imageBox_card position-relative mr-2 mb-1">
            <!--NAO PODEMOS DELETAR IMG DO SOFIA_GED -->
            <form @submit.prevent="excludeFile(item, index)">
              <button
                v-if="item.origem !== 'SOFIA_GED' "
                class="imageBox_card_delete d-inline-flex"
                type="submit"
                title="Deletar documento"
                @click="excludeFile(item, index)">
                <svg class="imageBox_card_delete_icon icon--xs"
                     role="presentation">
                  <use :xlink:href="'#' + deleteIcon.id" />
                </svg>
              </button>
              <svg v-if="item.origem === 'SOFIA_GED'"
                   class="imageBox_card_delete_icon  ged_icon icon--md"
                   role="presentation">
                <use :xlink:href="'#' + gedIcon.id" />
              </svg>

              <router-link class="imageBox_card_content row no-gutters justify-content-center text-decoration-none"
                           target="_blank"
                           :title="item.nome_original"
                           :to="{ name: 'sofia_rei_docs', params: getParams(item) }">
                <span class="imageBox_card_wrap d-inline-block">
                  <svg :class="`imageBox_card_wrap_icon icon--${iconSize}`"
                       role="presentation">
                    <use :xlink:href="'#' + perfilGed(item.codigo_perfil_ged || item.documento.codigo_perfil_ged)" />
                  </svg>
                </span>
                <p class="imageBox_card_text d-inline-block">
                  {{ item.nome_original }}
                </p>
              </router-link>
            </form>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>

  /* assets */
  import image from '@/assets/icons/cloud-image.svg?sprite'
  import addIcon from '@/assets/icons/add-circular.svg?sprite'
  import deleteIcon from '@/assets/icons/delete.svg?sprite'
  import outros from '@/assets/icons/outros.svg?sprite'
  import gedIcon from '@/assets/icons/ged-temp.svg?sprite'

  /* constants */
  import iconsList from '@/constants/iconProfile'
  import { ACCEPTED_MIME_TYPES } from '@/constants/fileUpload'

  /* services */
  import ArquivosService from '@/services/Arquivos/ArquivosService'

  /* libraries */
  import { mapGetters } from 'vuex'

  export default {
    name: "ImageBox",
    props: {
      imageList: { type: Array, default: () => [] },
      typeProfile: { type: String, default: () => "" },
      registroId: { type: Number, required: true },
      iconSize: {type: String, default: 'lg'} // sx, sm, md, lg
    },
    data () {
      return {
        outros,
        image,
        addIcon,
        deleteIcon,
        gedIcon,
        acceptedMimeTypes: ACCEPTED_MIME_TYPES.toString(),
        docs: [],
      }
    },
    computed: {
      ...mapGetters({
        getPreview: 'file/getPreview',
      })
    },
    methods: {
      excludeFile (file, index) {
        objSwal.question.title = 'Excluir arquivo'
        objSwal.question.text = 'Tem certeza que deseja excluir esse arquivo?'
        objSwal.question.cancelButtonText = 'Voltar'
        objSwal.question.confirmButtonText = 'Continuar'
        objSwal.question.html = ''

        objSwal.success.title = 'Arquivo excluído'
        objSwal.success.text = ''
        objSwal.success.html = ''

        objSwal.error.title = 'Exclusão não permitida'
        objSwal.error.text = ''
        objSwal.error.html = ''

        file.registro = {
          ...file.registro,
          registro_id: file.registro_id
        }
        file.arquivo = {
          ...file.arquivo,
          arquivo_id: file.arquivo_id
        }

        setTimeout(() => {
          const btnConfirm = document.querySelector('.swal2-cancel')

          if (btnConfirm) btnConfirm.focus()
        }, 300)

        Swal.fire(objSwal.question).then(res => {
          if (res.value) {
            ArquivosService.removeArquivo(file.arquivo_id || file.documento.arquivo_id).then(async () => {
              await Swal.fire(objSwal.success)

              this.$emit('removed', index)
            }).catch(res => {
              // objError.text = res.response.data.error.message;
              objSwal.error.text = res.response.data.message
              return Swal.fire(objSwal.error)
            })
          }
        })
      },
      perfilGed (id) {
        const perfil = iconsList.find(item => item.id == id)
        if (perfil) return perfil.iconId
        return outros.id
      },
      getParams (item) {
        let documentoId
        let origem

        if (item.origem && item.origem === 'SOFIA_GED') {
          documentoId = item.id
          origem = item.origem
        } else {
          documentoId = item.documento_id
          origem = 'SOFIA_REI'
        }
        item.origem = origem

        return {
          id: documentoId,
          origem: origem
        }
      }
    },
  }
</script>

<style lang="scss">
@import '../../../scss/_utilities/exports';

.imageBox {
  border-radius: pxToRem(4);

  &_title {
    @extend %titleIcon;

    &:before {
      background-image: url('../../../assets/icons/file-image.svg');
    }
  }

  &_container {
    padding: pxToRem(8) pxToRem(6) pxToRem(6) pxToRem(50);
  }

  &_card {
    cursor: pointer;
    background-color: $color-light-gray;
    border-radius: pxToRem(4);
    padding: pxToRem(2);
    transition: background-color .15s linear;
    width: 120px;

    &_content {
      //max-width: pxToRem(100);
    }

    &_text {
      color: $color-dark;
      font-size: pxToRem(12);
      font-weight: 500;
      margin: 0;
      text-align: center;
      max-width: pxToRem(100);
      border-radius: 50%;
      padding: pxToRem(6);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    &_wrap {
      background-color: $color-gray-light;
      border-radius: 50%;
      padding: pxToRem(6);

      &_icon {}
    }

    &_delete {
      border-radius: 50%;
      border: none;
      background-color: $color-red;
      height: pxToRem(24);
      left: pxToRem(-4);
      position: absolute;
      transition: background-color .15s linear;
      text-align: center;
      top: pxToRem(-4);
      width: pxToRem(24);

      &_icon {
        fill: $color-white;
      }

      &:hover {
        background-color: lighten($color-red, 15%);
        cursor: pointer;
      }
    }

    &:hover {
      background-color: darken(lightblue, 5%);
    }
  }
}
.ged_icon{
  position: absolute;
  left: -5px;
  top: -5px;

}
</style>
